import {Core} from '@strapi/strapi';
import {Update, Message} from '@telegraf/types';
import {Context} from "telegraf"
import {BotMessageTemplateType, TemplateConfig} from "../content-type/bot-message-template";
import {ExtraPhoto, ExtraReplyMessage} from "telegraf/src/telegram-types";

function replaceText(template: string, replacements: Record<string, string>): string {
  return template.replace(/\{(\w+)\}/g, (match, key) => {
    return replacements[key] || match;
  });
}

const BotBasicAction = ({strapi}: { strapi: Core.Strapi }) => ({
  telegramUser: strapi.plugin('telegram-bot').service('telegram-user'),
  botTemplate: strapi.plugin('telegram-bot').service<BotMessageTemplateType>('bot-message-template'),
  telegramGroup: strapi.plugin('telegram-bot').service('telegram-group'),
  telegramUserActivity: strapi.plugin('telegram-bot').service('telegram-user-activity'),
  async replyMessage (ctx: Context<Update.MessageUpdate>, config: TemplateConfig, replacements?: Record<string, string>) {
    try {
      if (config.type === 'reply') {
        const params = (config.params || {}) as ExtraReplyMessage;
        const message = !!replacements ? replaceText(config.input, replacements) : config.input;
        await ctx.reply(message, {
          ...params
        });
      } else if (config.type === 'replyWithPhoto') {
        const params = (config.params || {}) as ExtraPhoto;
        const _caption = String(params.caption || '');
        const caption = !!replacements ? replaceText(_caption, replacements) : _caption;

        await ctx.replyWithPhoto(config.input, {
          ...params,
          caption
        });
      }
    } catch (e) {
      console.error(e)
    }
  },
  async handleStart(ctx: Context<Update.MessageUpdate>) {
    const messageInfo = ctx.update.message;
    const botInfo = ctx.botInfo

    // Save user info if not existed
    const userInfo = messageInfo.from;

    // TODO: Issue-78 | Linking user with bot
    const userData = await this.telegramUser.upsertUser(userInfo, botInfo);
    const template = this.botTemplate.getWelcomeMessage();
    await this.replyMessage(ctx, template, {
      telegram_id: String(userData.telegram_id || ''),
      telegram_username: String(userData.telegram_username || ''),
      first_name: String(userData.first_name || ''),
      last_name: String(userData.last_name || ''),
      evm_wallet: String(userData.evm_wallet || ''),
    });
  },

  async handleHelp(ctx: Context<Update.MessageUpdate>) {
    const config = this.botTemplate.getHelpMessage();
    await this.replyMessage(ctx, config);
  },

  async handleMessage(ctx: Context<Update.MessageUpdate>) {
    const config = this.botTemplate.getAutoAnswerMessage();
    await this.replyMessage(ctx, config);
  },
});

export type BotBasicActionType = ReturnType<typeof BotBasicAction>;
export default BotBasicAction;
